import React, {useCallback, useMemo} from "react";
import {Grid} from '@mui/material'
import SortFilter from '../../SortFilter/SortFilter';
import {filterBySelectOption, sortByFields} from './data';
import {withSnackbar} from "../../hocs/withSnackbar";
import useUrlQueryParams from "../../../hooks/useUrlQueryParams";

const BuyerBookingFilter = ({
  setQuery,
}) => {

  const { bookingNumber } = useUrlQueryParams();

  const handleCallback = useCallback((e) =>{
    setQuery((prevState) => ({
      ...prevState,
      sortBy: e.sortBy,
      startDate: e.startDate,
      endDate: e.endDate,
      supplierName: e.filters?.find(item => item.name === "supplierName")?.value,
      bookingNumber: e.filters?.find(item => item.name === "bookingNumber")?.value,
      equipmentType: e.selectFilters?.find(item => item.name === "equipmentType")?.value,
      active: e.selectFilters?.find(item => item.name === "active")?.value,
      frequency: e.selectFilters?.find(item => item.name === "frequency")?.value,
      sortDir: e.sortDir
    }));
  },[setQuery]);

  const filterByOptions = useMemo(() => {
    return [
      {
        label: "Booking Number",
        value: bookingNumber || "",
        name: "bookingNumber",
        numberField: true,
        inputProps: { inputMode: "numeric" }
      },
      {
        label: "Supplier Name",
        value: "",
        name: "supplierName",
      }
    ]
  }, [bookingNumber]);

  return (
    <Grid item mb={2} sx={{
      '& .MuiInputLabel-root.Mui-error':{
        color:'rgba(0, 0, 0, 0.6) !important'
      },
      '& .MuiInput-root.Mui-error:before, .MuiInput-root.Mui-error:after':{
        borderBottom: '1px solid rgba(0, 0, 0, 0.42) !important'
      }
    }}>
      <SortFilter
        filterCallback={handleCallback}
        sortByOption={sortByFields}
        filterByOption={filterByOptions}
        filterBySelectOption={filterBySelectOption}
        defaultSortBy={sortByFields[2].value}
        sortDir={'desc'}
      />
    </Grid>
  )
}

export default withSnackbar(BuyerBookingFilter);
